module.exports = __webpack_public_path__ + "img/53_62.53bb14e6.png";